import { IRuleAspect } from '@quino/core';

export const BooleanIsTrueAspectIdentifier = 'BooleanIsTrue';

export interface IBooleanIsTrueAspect extends IRuleAspect {}
